<template>
  <div v-if="usedFor == 'global-search'">
    <div class="flex justify-between mb-4">
      <div>
        <div class="text-xl">{{ previewPaneData.name }}</div>
      </div>
      <Chip
        :label="previewPaneData.dealershipName"
        icon="location-dot"
        :rounded="false"
        size="sm"
      />
    </div>
    <AvatarLabelGroup
      :avatar-url="previewPaneData.vehicleManufacturerLogoUrl"
      avatar-is-logo
      :label="previewPaneData.vehicleModel"
      :description="previewPaneData.vehicleDerivative"
    />
    <img :src="previewPaneData.vehicleImageUrl" />
    <TermTracker
      :start-date="previewPaneData.startDate"
      :end-date="previewPaneData.endDate"
    />
  </div>

  <div v-else-if="usedFor == 'contact-panel'">
    <Chip
      :label="previewPaneData.dealershipName"
      icon="location-dot"
      class="mb-2"
      :rounded="false"
      size="sm"
    />

    <AvatarLabelGroup
      :avatar-url="previewPaneData.vehicleManufacturerLogoUrl"
      avatar-is-logo
      size="xs"
      :label="previewPaneData.vehicleModel"
      :description="previewPaneData.vehicleDerivative"
    />

    <div class="w-full flex justify-center">
      <img
        :src="previewPaneData.vehicleImageUrl"
        class="mb-2 max-h-32"
      />
    </div>
    <TermTracker
      :start-date="previewPaneData.startDate"
      :end-date="previewPaneData.endDate"
    />
  </div>
</template>

<script setup>
import AvatarLabelGroup from '@/components/avatar/AvatarLabelGroup.vue'
import TermTracker from '@/components/unique/trackers/TermTracker.vue'
import Chip from '@/components/chip/Chip.vue'

defineProps({
  previewPaneData: {
    type: Boolean,
    default: false
  },
  usedFor: {
    type: String,
    default: 'global-search' // options: 'global-search', 'contact-panel'
  }
})
</script>

<style></style>
